import { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { ChapterMarker } from './shared';
import { GALLERY, CONTACT } from '../assets';
import Lightbox from '../Lightbox';
import * as sfx from '../sfx';

export default function ChArchive() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = (i) => { sfx.rustle(); setLightboxIndex(i); };

  return (
    <section id="ch-archive" data-testid="chapter-archive" className="relative bg-[#0A0A0A] px-6 md:px-16 py-28 md:py-40">
      <ChapterMarker num="11" title="From the Archive" />

      <div className="flex items-end justify-between mb-10 md:mb-14">
        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight">
          From the <span className="italic text-[#B89B72]">archive</span>
        </h2>
        <span className="font-accent text-[9px] text-[#A3A3A3] hidden md:block">SELECTED WORK — EXPORT COLLECTIONS</span>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-5">
        {GALLERY.map((img, i) => (
          <motion.button
            key={img}
            data-testid={`gallery-item-${i + 1}`}
            data-hover
            onClick={() => openLightbox(i)}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.12 }}
            className="group relative overflow-hidden aspect-[3/4] border border-[#2A2A2A] bg-transparent p-0 text-left"
            aria-label={`View jacket photo ${i + 1} full screen`}
          >
            <img
              src={img}
              alt="PT Exports leather jacket"
              className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#0A0A0A]/25 group-hover:bg-transparent transition-colors duration-500" />
            <span className="absolute bottom-3 right-3 font-accent text-[8px] text-[#F5F5F0]/0 group-hover:text-[#F5F5F0]/70 transition-colors duration-500">EXPAND +</span>
          </motion.button>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border border-[#2A2A2A] bg-[#111111]/60 backdrop-blur-sm p-7 md:p-10"
      >
        <div>
          <h4 className="font-display text-2xl md:text-3xl font-light">Sourcing for your <span className="italic text-[#B89B72]">brand?</span></h4>
          <p className="font-body font-light text-sm text-[#A3A3A3] mt-2 max-w-md leading-relaxed">
            One tap opens WhatsApp with a ready-made enquiry — catalogue, MOQ and production details.
          </p>
        </div>
        <a
          href={CONTACT.whatsappEnquiry}
          target="_blank"
          rel="noreferrer"
          data-testid="request-catalogue-whatsapp"
          className="group inline-flex items-center gap-3 border border-[#B89B72]/60 text-[#B89B72] px-8 py-4 font-accent text-[10px] hover:bg-[#8C5A35]/20 transition-colors duration-300 whitespace-nowrap"
        >
          Request Catalogue
          <ArrowUpRight className="w-4 h-4" strokeWidth={1.2} />
        </a>
      </motion.div>

      <Lightbox images={GALLERY} index={lightboxIndex} onClose={() => setLightboxIndex(null)} onNavigate={setLightboxIndex} />
    </section>
  );
}
